import React from "react";

/**
 * StatCard — KPI tile used across the dashboard.
 *
 * Two visual modes:
 *  - default (no tone): minimal dark cell with mono numerals (legacy look)
 *  - tone="peach" | "mint" | "cream" | "pink": premium pastel paper card
 *    bridging the warm-dark workspace with the Landing V2 diorama palette.
 *
 * Accent is preserved for legacy callers and applies to the value color
 * only when `tone` is unset.
 */
const TONE_CLASS = {
  peach: "quill-card-peach",
  mint: "quill-card-mint",
  cream: "quill-card-cream",
  pink: "quill-card-pink",
};

const StatCard = ({ label, value, sub, accent, tone, testId }) => {
  if (tone && TONE_CLASS[tone]) {
    return (
      <div
        className={`${TONE_CLASS[tone]} p-5 md:p-6 m-1.5 md:m-2 rounded-xl relative overflow-hidden`}
        data-testid={testId}
      >
        <div
          className="text-[10px] uppercase tracking-[0.22em] opacity-70"
          style={{ color: "hsl(var(--quill-ink-warm))" }}
        >
          {label}
        </div>
        <div
          className="mt-3 font-display text-2xl md:text-3xl tracking-tight"
          style={{ color: "hsl(var(--quill-ink-warm))" }}
        >
          {value}
        </div>
        {sub && (
          <div
            className="text-xs mt-2 opacity-70"
            style={{ color: "hsl(var(--quill-ink-warm))" }}
          >
            {sub}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="p-5 md:p-6 border-r border-b border-[#2c241e]" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">{label}</div>
      <div
        className={`mt-3 font-mono text-2xl md:text-3xl tracking-tight ${
          accent === "success" ? "text-emerald-400" : accent === "warning" ? "text-amber-400" : "text-white"
        }`}
      >
        {value}
      </div>
      {sub && <div className="text-xs text-zinc-500 mt-2">{sub}</div>}
    </div>
  );
};

export default StatCard;
